import { ContactWidgetComponent } from './contact-widget.component';
import { ContactInfoService } from '../../services/contact-info.service';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { ModalConfig } from '../../../../../coverpath-common/js/interfaces/CoverpathTypes';
import { Component } from '@angular/core';

@Component({
  selector: 'contact-mmdirect-widget',
  templateUrl: './contact-widget-mmdirect.component.html',
})
export class ContactWidgetMmDirectComponent extends ContactWidgetComponent {
  policyType: string;
  data: ModalConfig;

  constructor(public contactUpdateService: ContactInfoService, public amorphicService: AmorphicService) {
    super(contactUpdateService, amorphicService);
  }

  ngOnInit() {
    this.contactUpdateService.setPolicyType(this.data.policyType);
  }
}
